/**
 * <rm-sticky-atc> — mobile sticky "Add to cart" bar.
 * Markup: sections/rm-sticky-atc.liquid
 *
 * - Shows only while the main product "Add to cart" button is scrolled
 *   above the viewport (CSS limits it to phones).
 * - Clicking forwards to the real Dawn button, so variant / quantity /
 *   sold-out handling is never duplicated.
 * - Re-syncs price + button state after every variant change
 *   (Dawn publishes PUB_SUB_EVENTS.variantChange after updating the DOM).
 */
if (!customElements.get('rm-sticky-atc')) {
  customElements.define(
    'rm-sticky-atc',
    class RmStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('.product__info-container [id^="ProductSubmitButton-"]');
        if (!this.mainButton) return;

        this.button = this.querySelector('[data-rm-sticky-button]');
        this.price = this.querySelector('[data-rm-sticky-price]');

        this.button.addEventListener('click', () => this.mainButton.click());

        this.observer = new IntersectionObserver(([entry]) => {
          // Visible only when the main button has scrolled ABOVE the viewport.
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle(scrolledPast);
        });
        this.observer.observe(this.mainButton);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            // Dawn may replace the button element when a variant changes.
            const freshButton = document.querySelector('.product__info-container [id^="ProductSubmitButton-"]');
            if (freshButton && freshButton !== this.mainButton) {
              this.observer.unobserve(this.mainButton);
              this.mainButton = freshButton;
              this.observer.observe(this.mainButton);
            }
            this.sync();
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
        document.body.classList.remove('rm-sticky-atc-visible');
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.button.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('rm-sticky-atc-visible', show);
      }

      sync() {
        // Button: mirror disabled state + label ("Add to cart" / "Sold out").
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.disabled = disabled;
        const label = this.mainButton.querySelector('span:not(.hidden)');
        if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();

        // Price: read the price currently shown in the main product block.
        const priceWrap = document.querySelector('.product__info-container .price');
        if (!priceWrap || !this.price) return;
        const current = priceWrap.classList.contains('price--on-sale')
          ? priceWrap.querySelector('.price__sale .price-item--last')
          : priceWrap.querySelector('.price__regular .price-item--regular');
        if (current && current.textContent.trim()) this.price.textContent = current.textContent.trim();
      }
    }
  );
}
